import { Box } from "@primer/react";
const HomePage = () => {

  return (
    <Box>

    </Box>

  );
}
export default HomePage
